import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import * as icons from 'react-bootstrap-icons';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import PatTab from './PatTab';
import DatePickerComponent from 'Utils/Helpers/DatePickerComponent';
import moment from "moment-jalaali";
import SelectComponent from 'Utils/Helpers/SelectComponent';
import { useSetState } from 'Utils/Helpers/Hooks';
import { enqueueSnackbar } from 'notistack';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { get_byDate, save_new, save_new_wp } from 'http/components/AppointmentService';
import { SetAppointmentsData } from 'Utils/Helpers/HandleApiData';
import DateCheck from 'Utils/Helpers/DateCheck';

export default function Create({ handleClose, reset, setReset }) {
    const dispatch = useDispatch();
    const [type, setType] = useState(null);
    const [tabValue, setTabValue] = useState('1');
    const [date, setDate] = useState(moment());
    const { appointmentTypes, selected, create_new, dateSearch} = useSelector((state) => ({
        appointmentTypes: state.setting.appointmentTypes,
        selected: state.setting.selected,
        create_new: state.setting.create_new,
        dateSearch: state.setting.dateSearch,
    }));

    useEffect(() => {
        setDate(moment(dateSearch.date, 'jYYYY/jMM/jDD'));
    }, [dateSearch.date])

    const [controls, setControls] = useSetState ({
        description: {
            id: "description",
            type: 'text',
            placeholder: 'توضیحات',
            value: '',
            icon: <icons.ChatDots/>,
        },
    });

    useEffect(() => {
        if(reset) {
            setControls({ description: { value: '' } });
            setReset(false);
        }
    }, [reset])

    useEffect(() => {
        if(appointmentTypes) setType(appointmentTypes[0].id)
    },[appointmentTypes])

    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
    }

    const onSelectChange = (e) => {
        setType(e);
    }

    const onSubmitAppointment = async () => {
        if(tabValue === '1') await submit_type_1();
        else if(tabValue === '2') await submit_type_2();
        else enqueueSnackbar('خطایی پیش آمده است، لطفا بروزرسانی کنید', {variant: 'warning'});
    }

    const submit_type_1 = async () => {
        if(selected) {
            dispatch(HandleLoading(true));
            const _date = date.locale("fa").format("jYYYY/jMM/jDD");
            if(DateCheck(_date)) {
                const response = await save_new(_date, dateSearch.dow, type, selected, controls.description.value);
                if(response.status) {
                    enqueueSnackbar('نوبت با موفقیت اضافه شد', {variant: 'success'});
                    const response2 = await get_byDate(dateSearch.date);
                    if(response2.status) {
                        await dispatch(SetAppointmentsData(response2.data));
                        handleClose();
                    } else {
                        dispatch(HandleLoading(false));
                    }
                } else {
                    dispatch(HandleLoading(false));
                }
            } else {
                enqueueSnackbar('تاریخ انتخاب شده گذشته است', {variant: 'warning'});
                dispatch(HandleLoading(false));
            }
        } else {
            enqueueSnackbar('بیمار انتخاب نشده است', {variant: 'warning'});
        }
    }

    const submit_type_2 = async () => {
        const {name, nCode, uniCode, mobile} = create_new;
        if(name !== '' && uniCode !== '') {
            dispatch(HandleLoading(true));
            const _date = date.locale("fa").format("jYYYY/jMM/jDD")
            const response = await save_new_wp(_date, dateSearch.dow, type, name, nCode, uniCode, mobile, controls.description.value);
            if(response.status) {
                enqueueSnackbar('نوبت با موفقیت اضافه شد', {variant: 'success'});
                const response2 = await get_byDate(dateSearch.date);
                if(response2.status) {
                    await dispatch(SetAppointmentsData(response2.data));
                    handleClose();
                } else {
                    dispatch(HandleLoading(false));
                }
            } else {
                dispatch(HandleLoading(false));
            }
        } else {
            enqueueSnackbar('اطلاعات به درستی وارد نشده است، فیلد‌های ستاره دار الزامی می باشند', {variant: 'error'});
            dispatch(HandleLoading(false));
        }
    }

    return (
        <>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-appointment-edit">
                    <div className='appointment-new'>
                    <div className='flex-row-center-center mb-2'>
                        <DatePickerComponent
                            icon={<icons.Calendar3/>}
                            value={date}
                            onChange={(e) => setDate(e)}
                        />
                    </div>
                    <div className='flex-row-center-center mb-2'>
                        <SelectComponent
                            name={'app-type'}
                            icon={<icons.Fingerprint/>}
                            options={appointmentTypes}
                            onChange={onSelectChange}
                        />
                    </div>
                    <PatTab
                        reset={reset}
                        setTab={(e) => setTabValue(e)}
                    />
                    <div className='border-top pt-2 mt-1'>
                        {
                            !reset && Object.keys(controls).map((key, index) => {
                                return (
                                    <Inputer
                                        key={`inputer_${controls[key].id}`}
                                        id={controls[key].id}
                                        type={controls[key].type}
                                        placeholder={controls[key].placeholder}
                                        value={controls[key].value}
                                        setValue={setControlsValue.bind(this)}
                                        icon={controls[key].icon}
                                        className={'mb-2'}
                                    />
                                )
                            })
                        }
                    </div>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CButton
                    text={'ذخیره نوبت جدید'}
                    icon={<icons.Save2/>}
                    onClick={onSubmitAppointment}
                />
            </DialogActions>
        </>
    );
}